const {
  GET_SUBMODULES_REQUEST,
  GET_SUBMODULES_SUCCESS,
  GET_SUBMODULES_FAILURE,
  GET_MODULES_REQUEST,
  GET_MODULES_SUCCESS,
  GET_MODULES_FAILURE,
  GET_COMPONENTS_REQUEST,
  GET_COMPONENTS_SUCCESS,
  GET_COMPONENTS_FAILURE,
  GET_ACTIONS_REQUEST,
  GET_ACTIONS_SUCCESS,
  GET_ACTIONS_FAILURE,
  GET_MODULESBY_SUBMODULES_REQUEST,
  GET_MODULESBY_SUBMODULES_SUCCESS,
  GET_MODULESBY_SUBMODULES_FAILURE,
  GET_API_REQUEST,
  GET_API_SUCCESS,
  GET_API_FAILURE,
  GET_ACTION_BY_SUBMODULES_REQUEST,
  GET_ACTION_BY_SUBMODULES_SUCCESS,
  GET_ACTION_BY_SUBMODULES_FAILURE,
  GET_ACTIONS_FOR_MAPPING_REQUEST,
  GET_ACTIONS_FOR_MAPPING_SUCCESS,
  GET_ACTIONS_FOR_MAPPING_FAILURE,
  GET_CLIENTS_REQUEST,
  GET_CLIENTS_SUCCESS,
  GET_CLIENTS_FAILURE,
  GET_USERS_BY_CLIENTID_REQUEST,
  GET_USERS_BY_CLIENTID_SUCCESS,
  GET_USERS_BY_CLIENTID_FAILURE,
} = require("./moduleManagementTypes");

const initialState = {
  loading: false,
  submodules: [],
  error: "",
};

const subModulesReducerForManagement = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUBMODULES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SUBMODULES_SUCCESS:
      return {
        loading: false,
        submodules: action.payload,
        error: "",
      };
    case GET_SUBMODULES_FAILURE:
      return {
        loading: false,
        submodules: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateForModule = {
  loading: false,
  modules: [],
  error: "",
};

const modulesReducerForManagement = (state = initialStateForModule, action) => {
  switch (action.type) {
    case GET_MODULES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_MODULES_SUCCESS:
      return {
        loading: false,
        modules: action.payload,
        error: "",
      };
    case GET_MODULES_FAILURE:
      return {
        loading: false,
        modules: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateForComponent = {
  loading: false,
  components: [],
  error: "",
};

const componentForModuleReducer = (
  state = initialStateForComponent,
  action
) => {
  switch (action.type) {
    case GET_COMPONENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_COMPONENTS_SUCCESS:
      return {
        loading: false,
        components: action.payload,
        error: "",
      };
    case GET_COMPONENTS_FAILURE:
      return {
        loading: false,
        components: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateForAction = {
  loading: false,
  actions: [],
  error: "",
};

const actionsForModuleReducer = (state = initialStateForAction, action) => {
  switch (action.type) {
    case GET_ACTIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ACTIONS_SUCCESS:
      return {
        loading: false,
        actions: action.payload,
        error: "",
      };
    case GET_ACTIONS_FAILURE:
      return {
        loading: false,
        actions: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateForSubModule = {
  loading: false,
  modules: [],
  error: "",
};

const moduleBySubmoduleReducer = (state = initialStateForSubModule, action) => {
  switch (action.type) {
    case GET_MODULESBY_SUBMODULES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_MODULESBY_SUBMODULES_SUCCESS:
      return {
        loading: false,
        modules: action.payload,
        error: "",
      };
    case GET_MODULESBY_SUBMODULES_FAILURE:
      return {
        loading: false,
        modules: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateForApi = {
  loading: false,
  api: [],
  error: "",
};

const apiForModuleReducer = (state = initialStateForApi, action) => {
  switch (action.type) {
    case GET_API_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_API_SUCCESS:
      return {
        loading: false,
        api: action.payload,
        error: "",
      };
    case GET_API_FAILURE:
      return {
        loading: false,
        api: [],
        error: action.payload,
      };
    default:
      return state;
  }
};



const initialStateForClients = {
  loading: false,
  clients: [],
  error: "",
};

const getAllClientsReducer = (state = initialStateForClients, action) => {
  switch (action.type) {
    case GET_CLIENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CLIENTS_SUCCESS:
      return {
        loading: false,
        clients: action.payload,
        error: "",
      };
    case GET_CLIENTS_FAILURE:
      return {
        loading: false,
        clients: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForUsers = {
  loading: false,
  users: [],
  error: "",
};

const getUsersByClientReducer = (state = initialStateForUsers, action) => {
  switch (action.type) {
    case GET_USERS_BY_CLIENTID_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_USERS_BY_CLIENTID_SUCCESS:
      return {
        loading: false,
        users: action.payload,
        error: "",
      };
    case GET_USERS_BY_CLIENTID_FAILURE:
      return {
        loading: false,
        users: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForMap = {
  loading: false,
  actions: [],
  error: "",
};

const actionForMappingReducer = (state = initialStateForMap, action) => {
  switch (action.type) {
    case GET_ACTIONS_FOR_MAPPING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ACTIONS_FOR_MAPPING_SUCCESS:
      return {
        loading: false,
        actions: action.payload,
        error: "",
      };
    case GET_ACTIONS_FOR_MAPPING_FAILURE:
      return {
        loading: false,
        actions: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateForSub = {
  loading: false,
  actions: [],
  error: "",
};

const actionBySubModuleReducer = (state = initialStateForSub, action) => {
  switch (action.type) {
    case GET_ACTION_BY_SUBMODULES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ACTION_BY_SUBMODULES_SUCCESS:
      return {
        loading: false,
        actions: action.payload,
        error: "",
      };
    case GET_ACTION_BY_SUBMODULES_FAILURE:
      return {
        loading: false,
        actions: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
export {
  subModulesReducerForManagement,
  modulesReducerForManagement,
  componentForModuleReducer,
  actionsForModuleReducer,
  moduleBySubmoduleReducer,
  apiForModuleReducer,
  actionBySubModuleReducer,
  actionForMappingReducer,
  getAllClientsReducer,
  getUsersByClientReducer
};
